import React, { useState, useEffect } from "react";
import SectionWrapper, { Container } from "./whychoose.style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Fade from "react-reveal/Fade";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

const WhyChoose = () => {
  const [whyChooseData, setWhyChooseData] = useState(null);
  // const apiUrl = process.env.GATSBY_API_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://radianceadmin.manageprojects.in/api/why-choose`);
        const jsonData = await response.json();
        if (jsonData.success && jsonData.data.length > 0) {
          setWhyChooseData(jsonData.data[0]);
        }
      } catch (error) {
        console.error('Error fetching why choose data:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <SectionWrapper id="whyChoose">
      <div className="myContainer">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div className="firstpara">
              {whyChooseData && (
                <div className="headB">
                  <Fade left>
                    <p>{whyChooseData.sub_heading}</p>
                    <h3 className="title">{whyChooseData.heading}</h3>
                  </Fade>
                </div>
              )}
              {whyChooseData && (
                <Fade right>
                  <p 
                    className="who-we-are-sec pt-20" 
                    dangerouslySetInnerHTML={{ __html: whyChooseData.description }} 
                  />
                </Fade>
              )}
            </div>
          </div>
          <div className="col-md-12 col-sm-12">
            <div className="row">
              <Fade bottom>
                <div className="col-md-12">
                  <div
                    className="reviewFold"
                    id="whyChooseSlider"
                    style={{ display: "block" }}
                  >
                    {whyChooseData && whyChooseData.slides && (
                      <Swiper
                        spaceBetween={20}
                        slidesPerView={2}
                        loop={true}
                        autoplay={{ delay: 3000 }}
                        navigation={{
                          prevEl: ".swiper-button-prevW",
                          nextEl: ".swiper-button-nextW",
                        }}
                        pagination={{ clickable: true }}
                        breakpoints={{
                          300: { slidesPerView: 1 },
                          768: { slidesPerView: 4 },
                        }}
                      >
                        {whyChooseData.slides.map((slide) => (
                          <SwiperSlide key={slide.id}>
                            <div className="whyCard">
                              <p className="numberIcon">
                                <span>{String(slide.id).padStart(2, '0')}</span>
                              </p>
                              <h4>{slide.slider_title}</h4>
                              <div 
                                className="desc" 
                                dangerouslySetInnerHTML={{ __html: slide.slider_description }} 
                              />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    )}
                    <div className="flex gReviewsIcos">
                      <div className="swiper-button-prevW">
                        <FontAwesomeIcon icon={faArrowLeft} />
                      </div>
                      <div className="swiper-button-nextW">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </div>
                    </div>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default WhyChoose;